import type { QueryKeyFactory } from "app/pages/sales-intelligence/types/queries";

const COMPANY_AUTOCOMPLETE_QUERY_KEY = "company-autocomplete";

type CompanyAutocompleteQueryFactory = QueryKeyFactory & {
    companyAutocomplete(term: string): readonly string[];
    companyAutocompleteList(domains: string[]): readonly string[];
};

export const companyAutocompleteQueryKeys: CompanyAutocompleteQueryFactory = {
    companyAutocomplete(term: string): readonly string[] {
        return [COMPANY_AUTOCOMPLETE_QUERY_KEY, term];
    },
    companyAutocompleteList(domains): readonly string[] {
        return [COMPANY_AUTOCOMPLETE_QUERY_KEY, "list", ...domains];
    },
};
